export default __webpack_public_path__ + "media/TechnologyMentorship.137cb189.svg";